import { render } from "./AyudaEmpresaForm.vue?vue&type=template&id=597f29a7&scoped=true"
import script from "./AyudaEmpresaForm.vue?vue&type=script&lang=js"
export * from "./AyudaEmpresaForm.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=597f29a7&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597f29a7"]])

export default __exports__